import type { GroupAttribute as GroupAttributeModel } from '@/adapters/catalogv1.g';

export function extractGroupAttribute(model: GroupAttributeModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    attributeRef: model.attribute_ref ?? '',
    value: model.value ?? '',
    type: model.type ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupAttribute = ReturnType<typeof extractGroupAttribute>;
